// French for the projection console (tab-portal-admin). Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  // ── masthead / page states ─────────────────────────────────────────────────
  'Client portal': 'Portail client',
  'No engagement selected': 'Aucun mandat sélectionné',
  'Portal access and publication are decided per engagement — the master switch, the object-type matrix and every publish flag hang off one engagement id.':
    "L’accès au portail et la publication se décident par mandat — le commutateur principal, la matrice des types d’objets et chaque indicateur de publication dépendent d’un seul identifiant de mandat.",
  'Resolving what the client would find…': 'Détermination de ce que le client trouverait…',
  'The projection could not be computed': "La projection n’a pas pu être calculée",
  'GET /api/portal-admin/projection did not answer.': "GET /api/portal-admin/projection n’a pas répondu.",
  'portal on': 'portail actif',
  'portal off': 'portail inactif',
  'The publish lists could not be read.': "Les listes de publication n’ont pas pu être lues.",
  'The publish lists could not be read': "Les listes de publication n’ont pas pu être lues",
  'No conversation on this engagement matches “{key}”.': 'Aucune conversation sur ce mandat ne correspond à «{key}».',

  // ── the rail ───────────────────────────────────────────────────────────────
  'REACHABLE': 'ACCESSIBLE',
  'SHARED': 'PARTAGÉ',
  'CAN SIGN IN': 'PEUT SE CONNECTER',
  'CLIENT LAST SEEN': 'DERNIÈRE VISITE CLIENT',
  'AWAITING YOU': 'EN ATTENTE DE VOUS',
  'the projection': 'la projection',
  'what is shared': 'ce qui est partagé',
  'people': 'Personnes',
  'the thread': 'le fil',
  'Open {what}': 'Ouvrir {what}',
  'the projection has not answered yet': "la projection n’a pas encore répondu",
  'off': 'inactif',
  'on‖state': 'actif',
  'views': 'vues',
  'the master switch is off': 'le commutateur principal est désactivé',
  '{n} of them would open empty': "{n} d’entre elles s’ouvriraient vides",
  'nothing renders': "rien ne s’affiche",
  'of {total}': 'sur {total}',
  '{n} staged, not written': '{n} en instance, pas encore écrites',
  'nothing published': 'rien de publié',
  '{sponsors} sponsor · {pending} invite pending': '{sponsors} sponsor · {pending} invitation en attente',
  'nobody invited': "personne n’est invité",
  'never': 'jamais',
  'd ago‖unit': 'j.',
  'no portal action on record': 'aucune action portail au dossier',
  'comment': 'commentaire',
  'comments': 'commentaires',
  '{n} day': '{n} jour',
  '{n} days': '{n} jours',
  'nothing unanswered': 'rien sans réponse',

  // ── the master switch band ─────────────────────────────────────────────────
  'The portal is': 'Le portail est',
  'for this engagement. Publication decides the rest.': 'pour ce mandat. La publication décide du reste.',
  'Every portal call is refused before publication is even consulted — grants and publish flags are kept, and take effect the moment it flips.':
    'Chaque appel au portail est refusé avant même que la publication soit consultée — les habilitations et les indicateurs de publication sont conservés, et prennent effet dès qu’il bascule.',
  'What they see': "Ce qu’ils voient",
  'Switch the portal off': 'Désactiver le portail',
  'Switch the portal on': 'Activer le portail',

  // ── zone 1 · next move ─────────────────────────────────────────────────────
  'Next move': 'Prochain coup',
  '{n} open': '{n} ouvert',
  '{n} more, ranked': '{n} autres, classés',

  // ── zone 2 · what the client would find ────────────────────────────────────
  'What the client would find': 'Ce que le client trouverait',
  '{n} of {total} views render': '{n} vues sur {total} s’affichent',
  'the portal is off — nothing renders': 'le portail est inactif — rien ne s’affiche',
  'Open the full preview →': "Ouvrir l’aperçu complet →",
  'The visibility matrix': 'La matrice de visibilité',
  'Nothing renders. With the master switch off every portal call is refused before publication is even consulted — a client who follows an invite gets a sign-in page and':
    "Rien ne s’affiche. Le commutateur principal étant désactivé, chaque appel au portail est refusé avant même que la publication soit consultée — un client qui suit une invitation obtient une page de connexion et",
  '“this engagement is not shared with you”': '«ce mandat n’est pas partagé avec vous»',
  '{n} view suppressed by one boolean. Their publication settings are kept and take effect the moment it flips.':
    "{n} vue supprimée par un seul commutateur. Leurs paramètres de publication sont conservés et prennent effet dès qu’il bascule.",
  '{n} views suppressed by one boolean. Their publication settings are kept and take effect the moment it flips.':
    "{n} vues supprimées par un seul commutateur. Leurs paramètres de publication sont conservés et prennent effet dès qu’il bascule.",
  'is hidden — the tab is not in their navigation': "est masqué — l’onglet n’apparaît pas dans leur navigation",
  'renders, and finds nothing': "s’affiche, et ne trouve rien",
  '0 of': '0 sur',
  'of': 'sur',
  'published': 'publiées',
  'always present': 'toujours présent',
  'Resolved from the same three gates the portal itself applies — engagement switch, object-type visibility, row flag. Nothing here is a screenshot and nothing here is a guess.':
    "Déterminé à partir des trois mêmes gates que le portail lui-même applique — commutateur du mandat, visibilité du type d’objet, indicateur de ligne. Rien ici n’est une capture d’écran et rien ici n’est une supposition.",
  'Signet portal': 'Portail Signet',
  'no tabs': 'aucun onglet',
  'Including {n} staged change — nothing is written yet.': "Dont {n} modification en instance — rien n’est encore écrit.",
  'Including {n} staged changes — nothing is written yet.': "Dont {n} modifications en instance — rien n’est encore écrit.",
  'Preview pins day paper — the portal has no theme toggle.': "L’aperçu reste figé en thème clair — le portail n’a pas de bascule de thème.",

  // ── zone 3 · what is shared ────────────────────────────────────────────────
  'What is shared': 'Ce qui est partagé',
  '{n} of {total} rows': '{n} sur {total} lignes',
  '{n} of {total} types visible': '{n} sur {total} types visibles',
  '{n} staged': '{n} en instance',
  'The shared tallies': 'Les compteurs de partage',
  'Reading the register…': 'Lecture du registre…',
  'Nothing loaded.': "Rien n’est chargé.",
  'no per-row flag': 'aucun indicateur par ligne',
  '{n} draft shared': '{n} brouillon partagé',
  '{n} drafts shared': '{n} brouillons partagés',
  'excluded': 'exclu',
  'visible, nothing exists': "visible, rien n’existe",
  'no client view lists these': 'aucune vue client ne les liste',
  '{label} visibility': 'Visibilité {label}',
  'hidden': 'masqué',
  'read‖access': 'lecture',
  'read + act': 'lecture + action',
  'read_act': 'lecture + action',
  'not in the portal': 'pas dans le portail',
  'the type gate is the whole decision': 'le gate du type est toute la décision',
  '{n} row on record, none reachable': '{n} ligne au dossier, aucune accessible',
  '{n} rows on record, none reachable': '{n} lignes au dossier, aucune accessible',
  'in scope shared': 'partagées dans le périmètre',
  'they can {act}': 'ils peuvent : {act}',
  'Defects carry no': "Les défauts n’ont pas de colonne",
  'column. The client raised them, so the type gate is the only decision there is.': '– le client les a consignés, le gate du type est donc la seule décision possible.',
  'Nothing of this kind exists in': "Rien de ce type n’existe encore dans",
  'yet.': '.',
  'The tab would still render for the client, and it would be empty.': "L’onglet s’afficherait quand même pour le client, et il serait vide.",
  'Share every held row in scope': 'Partager toutes les lignes retenues dans le périmètre',
  'Share none': 'Ne rien partager',
  'showing': 'Affichage',
  'exclusion': 'exclusion',
  'draft, and shared': 'brouillon, et partagé',
  'revised {date}, after the publish pass': 'révisé {date}, après la passe de publication',
  'flagged, and the portal still will not list it — it is {status}': 'marqué, et le portail ne le listera quand même pas — il est {status}',
  'to share': 'sera partagé',
  'to hide': 'sera masqué',
  'shared': 'partagé',
  'not shared': 'non partagé',
  'Show the remaining': 'Afficher le reste :',

  // ── zone 4 · who can sign in ───────────────────────────────────────────────
  'Who can sign in': 'Qui peut se connecter',
  '{n} account': '{n} compte',
  '{n} accounts': '{n} comptes',
  'Reading the accounts…': 'Lecture des comptes…',
  'Nobody at {client} can sign in.': 'Personne chez {client} ne peut se connecter.',
  '{n} contact is already on the client record — a portal account can be made from one without retyping it.':
    "{n} contact figure déjà au dossier client — un compte portail peut en être créé sans avoir à le ressaisir.",
  '{n} contacts are already on the client record — a portal account can be made from one without retyping it.':
    "{n} contacts figurent déjà au dossier client — un compte portail peut en être créé sans avoir à les ressaisir.",
  'No contact is on the client record either, so there is nobody to make an account from yet.':
    "Aucun contact ne figure non plus au dossier client ; il n’y a donc encore personne à partir de qui créer un compte.",
  'no email on record': 'aucun e-mail au dossier',
  'sponsor on the record': 'sponsor selon le dossier',
  'no role on record': 'aucun rôle au dossier',
  'no portal account': 'aucun compte portail',
  'This contact has no email address on record': "Ce contact n’a pas d’adresse e-mail au dossier",
  'Invite as sponsor': 'Inviter comme sponsor',
  'Invite as reviewer': 'Inviter comme reviewer',
  'The portal is off, so an invite issued now cannot be accepted. Switch it on in the masthead, or the link lands on a locked door.':
    "Le portail est inactif ; une invitation envoyée maintenant ne pourra donc pas être acceptée. Activez-le dans l’en-tête, sinon le lien atterrit devant une porte verrouillée.",
  'Create an account by hand': 'Créer un compte manuellement',
  'linked to the contact record': 'lié à la fiche contact',
  'disabled': 'désactivé',
  'active': 'actif',
  'invite expired': 'invitation expirée',
  'invited': 'invité',
  'no invite': 'aucune invitation',
  'Role for {name}': 'Rôle pour {name}',
  'sponsor': 'sponsor',
  'reviewer': 'reviewer',
  'last seen': 'dernière visite',
  'portal action': 'action portail',
  'portal actions': 'actions portail',
  'link expires': 'le lien expire le',
  'signed in, nothing done yet': "connecté, rien fait pour l’instant",
  'never signed in': 'jamais connecté',
  'granted {codes}': 'habilité pour {codes}',
  'Copy link': 'Copier le lien',
  'Re-invite': 'Réinviter',
  'Invite': 'Inviter',
  'Revoke': 'Révoquer',
  'Grants': 'Habilitations',
  'Re-enable': 'Réactiver',
  'Disable': 'Désactiver',
  'Delete': 'Supprimer',
  'New portal user': 'Nouvel utilisateur portail',
  'nothing — the account is disabled': 'rien — le compte est désactivé',
  'nothing until the invite is accepted': "rien tant que l’invitation n’est pas acceptée",
  '{read} (only a sponsor acts)': '{read} (seul un sponsor agit)',
  'read the overview, and nothing else': "lire l’aperçu, rien d’autre",

  // ── zone 5 · conversation ──────────────────────────────────────────────────
  'Conversation': 'Conversation',
  'awaiting-you not counted': '«en attente de vous» non comptabilisé',
  '{n} awaiting you of {total}': '{n} en attente de vous sur {total}',
  'The awaiting-you list': 'La liste «en attente de vous»',
  'Reading the threads…': 'Lecture des fils…',
  'Nothing has been said. A client comment lands here with the statement it is about, so the answer does not need a second tab.':
    "Rien n’a été dit. Un commentaire du client atterrit ici avec la déclaration qu’il concerne, afin que la réponse n’ait pas besoin d’un second onglet.",
  'Open {ref} in the Register': 'Ouvrir {ref} dans le registre',
  'Open the Register': 'Ouvrir le registre',
  'state unknown': 'état inconnu',
  'awaiting your reply': 'en attente de votre réponse',
  'answered': 'répondu',
  'Open the thread →': 'Ouvrir le fil →',
  'the statement they are asking about': 'la déclaration à propos de laquelle ils posent la question',
  'you': 'vous',
  'client': 'client',
  'Reply as the consultant': 'Répondre en tant que consultant',
  'This appears on {ref} in their portal.': 'Ceci apparaît sur {ref} dans leur portail.',
  'the object': "l’objet",
  'Sending…': 'Envoi…',
  'Send': 'Envoyer',
  'Open it in the Register': 'L’ouvrir dans le registre',

  // ── staging bar / dialogues ────────────────────────────────────────────────
  'share': 'partager',
  'stop sharing': 'ne plus partager',
  'not written yet': 'pas encore écrit',
  '{n} of them is still draft': "{n} d’entre elles est encore en brouillon",
  '{n} of them are still draft': "{n} d’entre elles sont encore en brouillon",
  '{n} is an exclusion': '{n} est une exclusion',
  '{n} are exclusions': '{n} sont des exclusions',
  'Discard': 'Abandonner',
  'Publish these': 'Publier ces éléments',
  'Change what the client can see': 'Modifier ce que le client peut voir',
  'Writing…': 'Écriture…',
  'Write {n} change': 'Écrire {n} modification',
  'Write {n} changes': 'Écrire {n} modifications',
  'Share': 'Partager',
  'and': 'et',
  'for': 'pour',
  'of them is still': "d’entre elles est encore",
  'of them are still': "d’entre elles sont encore",
  'draft': 'brouillon',
  'in the register. A draft statement shown to a client reads as a commitment.': "dans le registre. Une déclaration en brouillon montrée à un client se lit comme une promesse.",
  'is descoped or explicitly out of scope': 'est retiré du périmètre ou explicitement hors périmètre',
  'are descoped or explicitly out of scope': 'sont retirés du périmètre ou explicitement hors périmètre',
  'Showing an exclusion to a client is a contractual statement about what you are': 'Montrer une exclusion à un client est une déclaration contractuelle sur ce que vous',
  'not': 'ne faites pas',
  'doing — publish it only if you mean to make that point.': '— ne la publiez que si c’est exactement le message que vous voulez faire passer.',
  'Switching…': 'Basculement…',
  'Switch it off': 'Désactiver',
  'Every portal call for': 'Chaque appel au portail pour',
  'is refused from the moment this is written — anyone signed in loses the engagement on their next click.':
    "est refusé dès l’instant où ceci est écrit — quiconque est connecté perd le mandat au clic suivant.",
  'published row': 'ligne publiée',
  'published rows': 'lignes publiées',
  'account': 'compte',
  'accounts': 'comptes',
  'stay exactly as they are and take effect again the moment it is switched back on.': "restent exactement tels quels et reprennent effet dès qu’il est réactivé.",
  'Portal account for {name}': 'Compte portail pour {name}',
  'Name': 'Nom',
  'Email': 'E-mail',
  'Role': 'Rôle',
  'reviewer — runs UAT, comments, raises defects': 'reviewer — exécute les UAT, commente, signale des défauts',
  'sponsor — also signs the SOW, decides CRs, signs acceptance': 'sponsor — signe également le SOW, tranche les demandes de modification, signe l’acceptation',
  'The account is granted': 'Le compte est habilité',
  'straight away and cannot sign in until an invite is accepted and a password set.': "immédiatement, mais ne peut se connecter tant qu’une invitation n’est pas acceptée et qu’un mot de passe n’est pas défini.",
  'The contact record is linked, so the two never drift apart.': 'La fiche contact est liée, si bien que les deux ne divergent jamais.',
  'The portal is off for this engagement, so the account will exist and reach nothing until the master switch is on.':
    "Le portail est inactif pour ce mandat ; le compte existera donc sans rien atteindre tant que le commutateur principal n’est pas activé.",
  'Cancel': 'Annuler',
  'Create': 'Créer',
  'Engagement grants — {name}': 'Habilitations du mandat — {name}',
  'A grant only covers engagements of {client}. Without one, the portal returns “not shared with you”.':
    'Une habilitation ne couvre que les mandats de {client}. Sans elle, le portail répond «pas partagé avec vous».',
  'Done': 'Terminé',
  'Delete {name}': 'Supprimer {name}',
  '{name} cannot be deleted': '{name} ne peut pas être supprimé',
  'This account': 'Ce compte',
  'Deleting…': 'Suppression…',
  'Delete permanently': 'Supprimer définitivement',
  'Already disabled': 'Déjà désactivé',
  'Disable instead': 'Désactiver à la place',
  'This account has left no record behind, so it can simply go. An account that has signed, tested or raised anything is disabled instead.':
    "Ce compte n’a laissé aucune trace, il peut donc simplement disparaître. Un compte qui a signé, testé ou signalé quoi que ce soit est désactivé à la place.",
  'Any outstanding invite link dies with it. The audit log keeps the record.': "Tout lien d’invitation encore actif s’éteint avec lui. La piste d’audit conserve l’entrée.",

  // ── toasts ─────────────────────────────────────────────────────────────────
  'The portal is on — grants and publication settings now take effect': 'Le portail est actif — les habilitations et les paramètres de publication prennent effet dès maintenant',
  'The portal is off — clients lose access immediately': "Le portail est inactif — les clients perdent l’accès immédiatement",
  'Could not change the portal switch': 'Impossible de modifier le commutateur du portail',
  'Could not save the publication setting': "Impossible d’enregistrer le paramètre de publication",
  '{table} was refused': '{table} a été refusé',
  '{n} row written': '{n} ligne écrite',
  '{n} rows written': '{n} lignes écrites',
  'Reply posted — the client sees it on the object': "Réponse envoyée — le client la voit sur l’objet",
  'Could not post the reply': "Impossible d’envoyer la réponse",
  '{name} created and granted {code}': '{name} créé et habilité pour {code}',
  'Could not create the portal user': "Impossible de créer l’utilisateur portail",
  'Invite issued for {name} — the link is on their row': 'Invitation créée pour {name} — le lien figure sur sa ligne',
  'Could not issue the invite': "Impossible de créer l’invitation",
  'The outstanding invite for {name} is dead': "L’invitation en cours pour {name} est éteinte",
  'Could not revoke the invite': "Impossible de révoquer l’invitation",
  'Invite link copied': "Lien d’invitation copié",
  'Clipboard blocked — select the link and copy it manually': 'Presse-papiers bloqué — sélectionnez le lien et copiez-le manuellement',
  'Could not change the grant': "Impossible de modifier l’habilitation",
  '{name} re-enabled': '{name} réactivé',
  '{name} disabled': '{name} désactivé',
  'Could not update the user': "Impossible de mettre à jour l’utilisateur",
  'Could not change the role': 'Impossible de modifier le rôle',
  'Could not work out what removing this account would do': 'Impossible de déterminer l’effet du retrait de ce compte',
  '{name} disabled — access is gone, the record stands': '{name} désactivé — l’accès a disparu, le dossier reste',
  '{name} removed': '{name} retiré',
  'Could not remove the user': "Impossible de retirer l’utilisateur",
  'Could not create a preview link': "Impossible de créer un lien d’aperçu",

  // ── the miniature ──────────────────────────────────────────────────────────
  'Password': 'Mot de passe',
  'Sign in': 'Se connecter',
  'this engagement is not shared with you': "ce mandat n’est pas partagé avec vous",
  'No view renders for this client.': 'Aucune vue ne s’affiche pour ce client.',
  'The overview summarises the tabs below': "L’aperçu résume les onglets ci-dessous",
  'Nothing has been published to you yet.': "Rien ne vous a encore été publié.",
  'This tab is in their navigation and it is empty.': 'Cet onglet figure dans leur navigation et il est vide.',
  'is': 'est',
  '0 of {total} rows published.': '0 sur {total} lignes publiées.',
  'more': 'de plus',

  // ── portal vocabulary (src/shared/portalViews.ts, wrapped at the render site) ──
  'Requirements': 'Exigences',
  'Acceptance criteria': "Critères d’acceptation",
  'Deliverables': 'Livrables',
  'Documents': 'Documents',
  'Test cases': 'Cas de test',
  'Milestones': 'Jalons',
  'SOW versions': 'Versions du SOW',
  'Change requests': 'Demandes de modification',
  'Acceptance records': "Procès-verbaux d’acceptation",
  'Defects': 'Défauts',
  'requirements': 'exigences',
  'acceptance criteria': "critères d’acceptation",
  'deliverables': 'livrables',
  'documents': 'documents',
  'test cases': 'cas de test',
  'milestones': 'jalons',
  'sow versions': 'versions du SOW',
  'change requests': 'demandes de modification',
  'acceptance records': "procès-verbaux d’acceptation",
  'defects': 'défauts',
  'Overview': 'Aperçu',
  'Statement of work': 'Descriptif des prestations',
  'UAT': 'UAT',
  'Acceptance': 'Acceptation',
  'overview': 'aperçu',
  'statement of work': 'descriptif des prestations',
  'uat': 'UAT',
  'acceptance': 'acceptation',
  'read the statements': 'lire les déclarations',
  'comment · propose a change': 'commenter · proposer une modification',
  'read the criteria, nested under the requirement they test': "lire les critères, imbriqués sous l’exigence qu’ils testent",
  'named on other objects; no client view lists these': 'nommés sur d’autres objets ; aucune vue client ne les liste',
  'read · download': 'lire · télécharger',
  'download · upload new': 'télécharger · téléverser une nouvelle version',
  'read the cases': 'lire les cas',
  'record pass / fail / blocked': 'consigner réussi / échoué / bloqué',
  'sponsor signs → creates the baseline': 'le sponsor signe → crée la baseline',
  'read the requests': 'lire les demandes',
  'sponsor approves or rejects': 'le sponsor approuve ou rejette',
  'read the record': 'lire le procès-verbal',
  'sponsor signs': 'le sponsor signe',
  'read the defects they raised': "lire les défauts qu’il a signalés",
  'raise a defect': 'signaler un défaut',
  'the summary of everything below': 'le résumé de tout ce qui suit',
  'sponsor signs → creates the baseline (sponsor only)': 'le sponsor signe → crée la baseline (sponsor uniquement)',
  'sponsor approves or rejects (sponsor only)': 'le sponsor approuve ou rejette (sponsor uniquement)',
  'sponsor signs (sponsor only)': 'le sponsor signe (sponsor uniquement)',

  // ── engagement phases (rendered raw from the server) ───────────────────────
  'qualify': 'Qualification',
  'discovery': 'Discovery',
  'design': 'Conception',
  'contracting': 'Contractualisation',
  'mobilise': 'Mobilisation',
  'implement': 'Réalisation',
  'handover': 'Transfert',
  'close': 'Clôture',

  // ── row statuses (rendered raw from the register) ──────────────────────────
  'proposed': 'proposé',
  'held': 'retenu',
  'pending': 'en attente',
  'accepted': 'accepté',
  'rejected': 'refusé',
  'ready': 'prêt',
  'dropped': 'abandonné',
  'failed': 'échoué',
  'passed': 'réussi',
  'blocked': 'bloqué',
  'descoped': 'retiré du périmètre',
  'baselined': 'dans la baseline',
  'delivered': 'livré',
  'planned': 'planifié',
  'in_progress': 'en cours',
  'confirmed': 'confirmé',
  'signed': 'signé',
  'superseded': 'remplacé',
  'open': 'ouvert',
  'resolved': 'résolu',
  'approved': 'approuvé',
}, 'PortalAdminPage');
